// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hgo-requests-table-wrapper {
  width: 100% !important;
  overflow-x: auto;
  max-width: 100% !important;
}

.hgo-requests-table-wrapper table,
.hgo-requests-table {
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  table-layout: fixed !important;
}

.hgo-requests-table-wrapper table th:nth-child(1),
.hgo-requests-table-wrapper table td:nth-child(1),
.hgo-requests-table th:nth-child(1),
.hgo-requests-table td:nth-child(1) {
  width: 15% !important;
  min-width: 15% !important;
  max-width: 15% !important;
}

.hgo-requests-table-wrapper table th:nth-child(2),
.hgo-requests-table-wrapper table td:nth-child(2),
.hgo-requests-table th:nth-child(2),
.hgo-requests-table td:nth-child(2) {
  width: 25% !important;
  min-width: 25% !important;
  max-width: 25% !important;
}

.hgo-requests-table-wrapper table th:nth-child(3),
.hgo-requests-table-wrapper table td:nth-child(3),
.hgo-requests-table th:nth-child(3),
.hgo-requests-table td:nth-child(3) {
  width: 35% !important;
  min-width: 35% !important;
  max-width: 35% !important;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
}

.hgo-requests-table-wrapper table th:nth-child(4),
.hgo-requests-table-wrapper table td:nth-child(4),
.hgo-requests-table th:nth-child(4),
.hgo-requests-table td:nth-child(4) {
  width: 25% !important;
  min-width: 25% !important;
  max-width: 25% !important;
}

.hgo-requests-table .actions-cell {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  flex-wrap: nowrap;
}

.hgo-requests-table .actions-cell button {
  min-width: 100px;
  width: 100px;
  flex-shrink: 0;
}

.hgo-table-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  margin-right: 0 !important;
}

.hgo-table-container {
  width: 100% !important;
  max-width: 100% !important;
  max-height: calc(100vh - 250px);
  padding: 0 !important;
}

@media (min-width: 1024px) {
  .hgo-requests-table-wrapper {
    width: 100%;
    max-width: 100%;
  }
  
  .hgo-requests-table {
    width: 100%;
    max-width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Pages/HGO/Dashboard/HgoRequst/HgoRequestComponents/Table.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".hgo-requests-table-wrapper {\n  width: 100% !important;\n  overflow-x: auto;\n  max-width: 100% !important;\n}\n\n.hgo-requests-table-wrapper table,\n.hgo-requests-table {\n  width: 100% !important;\n  min-width: 100% !important;\n  max-width: 100% !important;\n  table-layout: fixed !important;\n}\n\n.hgo-requests-table-wrapper table th:nth-child(1),\n.hgo-requests-table-wrapper table td:nth-child(1),\n.hgo-requests-table th:nth-child(1),\n.hgo-requests-table td:nth-child(1) {\n  width: 15% !important;\n  min-width: 15% !important;\n  max-width: 15% !important;\n}\n\n.hgo-requests-table-wrapper table th:nth-child(2),\n.hgo-requests-table-wrapper table td:nth-child(2),\n.hgo-requests-table th:nth-child(2),\n.hgo-requests-table td:nth-child(2) {\n  width: 25% !important;\n  min-width: 25% !important;\n  max-width: 25% !important;\n}\n\n.hgo-requests-table-wrapper table th:nth-child(3),\n.hgo-requests-table-wrapper table td:nth-child(3),\n.hgo-requests-table th:nth-child(3),\n.hgo-requests-table td:nth-child(3) {\n  width: 35% !important;\n  min-width: 35% !important;\n  max-width: 35% !important;\n  word-wrap: break-word;\n  white-space: normal;\n  overflow-wrap: break-word;\n}\n\n.hgo-requests-table-wrapper table th:nth-child(4),\n.hgo-requests-table-wrapper table td:nth-child(4),\n.hgo-requests-table th:nth-child(4),\n.hgo-requests-table td:nth-child(4) {\n  width: 25% !important;\n  min-width: 25% !important;\n  max-width: 25% !important;\n}\n\n.hgo-requests-table .actions-cell {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  flex-wrap: nowrap;\n}\n\n.hgo-requests-table .actions-cell button {\n  min-width: 100px;\n  width: 100px;\n  flex-shrink: 0;\n}\n\n.hgo-table-wrapper {\n  width: 100% !important;\n  max-width: 100% !important;\n  margin-right: 0 !important;\n}\n\n.hgo-table-container {\n  width: 100% !important;\n  max-width: 100% !important;\n  max-height: calc(100vh - 250px);\n  padding: 0 !important;\n}\n\n@media (min-width: 1024px) {\n  .hgo-requests-table-wrapper {\n    width: 100%;\n    max-width: 100%;\n  }\n  \n  .hgo-requests-table {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
